import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'consenso-privacy-policy',
  templateUrl: './consenso-privacy-policy.component.html',
  styleUrls: ['./consenso-privacy-policy.component.scss']
})
export class ConsensoPrivacyPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
